import { ImageViewerProps } from './ImageViewer.types'
import Lightbox from '../lightbox/Lightbox'

const ImageViewer = ({ currentIndex, ...props }: ImageViewerProps) => {
    return <Lightbox {...props} closeOnClickOutside backgroundStyle={{ zIndex: 1000 }} currentIndex={currentIndex} />
}

export default ImageViewer
